const EventEmitter = require('eventemitter3');

const progressBar = document.querySelector('#pageProgressBarFill');
const container = document.querySelector('#pageProgressBar');
const emitter = new EventEmitter();
const points = [];



const _addPoint = container => {
    const p = document.createElement('SPAN');
    p.classList.add('sidemenu__progressbar__point');
    p.innerHTML = '<b><i></i></b>';
    container.appendChild(p);
    points.push(p);
    return p;
}

const _setValue = (point, value) => {
    point.style.top = `${value * 100}%`;
    return point;
}

const _addListener = (point, index) => {
    point.addEventListener('click', () => {
        emitter.emit('request', index);
    });
    return point;
}

// const _set

emitter.initCuePoints = arr => {
    let i;
    for (i = 0; i < arr.length; i++) {
        _addListener(_setValue(_addPoint(container), arr[i]), i);
    }
};

emitter.setProgress = value => {
    progressBar.style.transform = `scale(1, ${value})`;

    // TODO: active point
};

emitter.setCurrentCuePoint = i => {
    if (i < 0 || i >= points.length) return;
    points.forEach(el => {
        el.classList.remove('active');
    });
    points[i].classList.add('active');
};


module.exports = emitter;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/ProgressBar.js